import { MapTo } from '@adobe/aem-react-editable-components';
import FilterMenu, { FilterMenuEditConfig } from './FilterMenu';

export default MapTo('cob-corp-acquisition/components/creditonebank/filter-menu')(FilterMenu, FilterMenuEditConfig);